import React from 'react';
import axios from 'axios';
import MediaQuery from 'react-responsive';

import ErrorPage from './ErrorPage';
import TableRank from './TableRank';

class Ranking extends React.Component {
  constructor() {
    super();
    this.state = {
      usersByScoreForDesktop: [],
      usersByScoreForMobile: [],
      isError: false,
      error: {}
    };
    this.getScoresDesktop = this.getScoresDesktop.bind(this);
    this.getScoresMobile = this.getScoresMobile.bind(this);
  }

  componentDidMount() {
    this.getScoresDesktop();
    this.getScoresMobile();
  }

  getScoresDesktop() {
    axios
      .get('https://c-clicker-api.herokuapp.com/users')
      .then(res => {
        const datas = res.data;
        datas.sort((a, b) => b.score - a.score);
        datas.splice(10);
        this.setState({ usersByScoreForDesktop: datas });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
    setTimeout(() => this.getScoresDesktop(), 1000);
  }

  getScoresMobile() {
    axios
      .get('https://c-clicker-api.herokuapp.com/users')
      .then(res => {
        const datas = res.data;
        datas.sort((a, b) => b.score - a.score);
        datas.splice(5);
        this.setState({ usersByScoreForMobile: datas });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
    setTimeout(() => this.getScoresMobile(), 1000);
  }

  render() {
    const { usersByScoreForDesktop, usersByScoreForMobile, isError, error } = this.state;

    if (isError) {
      return <ErrorPage error={error} />;
    } else {
      return (
        <div>
          <MediaQuery maxWidth={992}>
            <TableRank users={usersByScoreForMobile} />
          </MediaQuery>
          <MediaQuery minWidth={993}>
            <TableRank users={usersByScoreForDesktop} />
          </MediaQuery>
        </div>
      );
    }
  }
}

export default Ranking;
